import { render, staticRenderFns } from "./IconSvgDollar.vue?vue&type=template&id=0996eaaa&scoped=true&"
import script from "./IconSvgDollar.vue?vue&type=script&lang=js&"
export * from "./IconSvgDollar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996eaaa",
  null
  
)

export default component.exports